import { getUserBalance, } from "./getUserBalance";
import { getChainedTokens, type Address, type ChainId, type TokenDefinition, } from "@bracket/addressbook";
import { getChainId, } from "@helpers";

import type { ExecutableToken, } from "@types";



export declare type GetUserBalancesProps = {
	wallet: Address;
	chain?: ChainId;
	force?: boolean;
}



export const getUserBalances = async ({
	wallet,
	chain,
	force = false,
}: GetUserBalancesProps): Promise<Record<TokenDefinition["label"], bigint>> => {
	try {
		chain = chain || getChainId() as ChainId;
		const result = {} as Record<TokenDefinition["label"], bigint>;
		for(const token of getChainedTokens(chain)) {
			if(token.symbol === "ETH")
				continue;
			const value = await getUserBalance({ chain, wallet, token, force, });
			result[token.label] = value;
		}
		return result;
	}
	catch( err ) {
		console.warn(`failed getting user balances on chain ${chain}`, Object.assign({}, err));
		throw new Error("getUserBalances has failed.");
	}
}
